<template>
  <div class="content-main relative">
    <BaseOrderModal
      @closeOrder="openedOrder = ''"
      :orderUUID="openedOrder"
      @nextOrder="openNextOrder"
      @previousOrder="openPreviousOrder"
      v-model="showOrderModal"
      @orderUpdated="loadOrders"
      :hasNext="hasNext"
      :hasPrev="hasPrev"
    />
    <template>
      <BaseLeftPageSubMenu
        :menuItems="orderStatusOptions"
        :selectedStatus="filters.exportStatus"
        :searchProp="filters.search"
        @selectedStatusFilter="updateStatusFilter"
        @searchUpdated="updateSearchFilter"
      >
        <label>{{ $t("message.infoauto_orders_page.search_orders") }}</label>
      </BaseLeftPageSubMenu>
      <div class="content">
        <div class="header flex flex-row">
          <BaseMiniSpinner v-if="loading" class="mr-2" />
          <div>
            {{ $t("message.infoauto_orders_page.title") }}
          </div>
          <button
            class="btn-dark-button absolute right-2 top-2"
            @click="exportAllOrders()"
            v-if="infoautoExportEnabled"
          >
            <span v-if="!exportingOrders">
              {{ $t("message.infoauto_orders_page.export_button") }}
            </span>
            <BaseMiniSpinner v-else></BaseMiniSpinner>
          </button>
        </div>
        <div class="table">
          <table class="default-table">
            <thead>
              <tr class="table100-head">
                <th
                  v-for="headerItem in tableHeaders"
                  :key="headerItem.value"
                  @click="changeArrowDir(headerItem.value)"
                >
                  {{ headerItem.displayText }}
                  <span v-if="filters.orderCol == headerItem.value">
                    <img
                      :src="
                        require(`@/assets/icons/${arrowDirection}-arrow.svg`)
                      "
                    />
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="order in orders"
                :key="order.id"
                @click="openOrder(order.orderNumber)"
                :class="{
                  selected: selectedOrder == order.id,
                  warning: order.statusPayment == 0
                }"
              >
                <td>
                  <a>
                    {{ order.orderNumber }}
                  </a>
                </td>
                <td>
                  {{ order.orderDate | dateWithHours }}
                </td>
                <td style="max-width: 80px">
                  <BaseTooltip
                    :text="order.products"
                    :disabled="!order.products || order.products == ''"
                  >
                    {{ order.products }}
                  </BaseTooltip>
                </td>
                <td style="max-width: 80px">
                  <BaseTooltip
                    :text="order.shippingAddressName"
                    :disabled="
                      !order.shippingAddressName ||
                        order.shippingAddressName == ''
                    "
                  >
                    {{ order.shippingAddressName }}
                  </BaseTooltip>
                </td>
                <td>
                  {{ order.shippingAddressState }}
                </td>
                <td>
                  {{ order.shippingAddressCountry }}
                </td>
                <td>
                  {{ order.createdBy }}
                </td>
                <td>
                  {{ order.total }}
                </td>
                <td>
                  {{ order.shippingPreference }}
                </td>
                <td>
                  <div
                    v-if="order.vin !== '' && order.vin !== null"
                    class="w-5 h-5 bg-green-500 rounded-full border-2 border-black"
                  ></div>
                </td>
                <td>({{ order.storeSource }}){{ order.salesman }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="footer">
          <div class="totals">
            {{ $t("message.infoauto_orders_page.showing") }}
            {{ filters.limitPerPage * (filters.page - 1) }}
            {{ $t("message.infoauto_orders_page.to") }} {{ toQuantity() }}
            {{ $t("message.infoauto_orders_page.from") }} {{ totalItems }}
            {{ $t("message.infoauto_orders_page.results") }}
          </div>
          <div class="pages">
            <select
              v-model="ordersByPage"
              @change="
                (filters.limitPerPage = ordersByPage), (filters.page = 1)
              "
            >
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="500">500</option>
            </select>
            {{ $t("message.infoauto_orders_page.per_page") }}
          </div>
          <div class="pages">
            <div>
              <a
                :class="{ disabled: filters.page == 0 }"
                class="page-link"
                @click="previous()"
                >{{ $t("message.infoauto_orders_page.previous") }}</a
              >
            </div>
            <div>
              {{ $t("message.infoauto_orders_page.page") }} {{ filters.page }}
            </div>
            <div>
              <a
                :class="{
                  disabled: totalPages > filters.page
                }"
                class="page-link"
                @click="next()"
                >{{ $t("message.infoauto_orders_page.next") }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { createQueryString } from "@/api/store/OrdersService.js";
import {
  getInfoautoOrders,
  exportAllOrdersInfoauto,
  getOrdersQtyByInfoautoStatus
} from "@/api/store/Infoauto.js";
import camelize from "camelize";
import { mapGetters } from "vuex";

const baseFilters = {
  exportStatus: "not_migrated",
  page: 1,
  limitPerPage: 100,
  orderCol: "orderDate",
  orderDir: "desc",
  search: ""
};
export default {
  name: "OrdersPage",
  data() {
    return {
      publicPath: process.env.VUE_APP_IMG_BASE_URL,
      orderStatusQty: {
        not_migrated: 0,
        error_migrating: 0,
        migrated: 0
      },
      filters: JSON.parse(JSON.stringify(baseFilters)),
      filtersKey: 0,
      ordersByPage: 100,
      orders: [],
      totalItems: 0,
      totalPages: 0,
      loading: true,
      selectedOrder: null,
      openedOrder: "",
      showOrderModal: false,
      showFilters: false,
      apiCallId: null,
      hasNext: false,
      hasPrev: false,
      windowIsFocused: true,
      generalStatus: null,
      exportingOrders: false
    };
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.loading = true;
        const query = {
          ...this.$route.query,
          search: createQueryString(this.filters)
        };
        this.$router.replace({ query }).catch(() => {});
        this.loadOrders();
      }
    },
    showFilters() {
      const query = {
        ...this.$route.query,
        showFilters: this.showFilters
      };
      this.$router.replace({ query }).catch(() => {});
    }
  },
  computed: {
    arrowDirection() {
      return this.filters.orderDir == "desc" ? "down" : "up";
    },
    tableHeaders() {
      return [
        {
          displayText: this.$t(
            "message.infoauto_orders_page.table_headers.order_number"
          ),
          value: "orderNumber"
        },
        {
          displayText: this.$t(
            "message.infoauto_orders_page.table_headers.order_date"
          ),
          value: "orderDate"
        },
        {
          displayText: this.$t(
            "message.infoauto_orders_page.table_headers.products"
          ),
          value: "products"
        },
        {
          displayText: this.$t(
            "message.infoauto_orders_page.table_headers.shipping_name"
          ),
          value: "shippingName"
        },
        {
          displayText: this.$t(
            "message.infoauto_orders_page.table_headers.state"
          ),
          value: "state"
        },
        {
          displayText: this.$t(
            "message.infoauto_orders_page.table_headers.country"
          ),
          value: "country"
        },
        {
          displayText: this.$t(
            "message.infoauto_orders_page.table_headers.created_by"
          ),
          value: "createdBy"
        },
        {
          displayText: this.$t(
            "message.infoauto_orders_page.table_headers.total"
          ),
          value: "total"
        },
        {
          displayText: this.$t(
            "message.infoauto_orders_page.table_headers.shipping_preference"
          ),
          value: "shippingPreference"
        },
        {
          displayText: this.$t(
            "message.infoauto_orders_page.table_headers.vin"
          ),
          value: "vin"
        },
        {
          displayText: this.$t(
            "message.infoauto_orders_page.table_headers.seller"
          ),
          value: "marketplace"
        }
      ];
    },
    orderStatusOptions() {
      return [
        {
          displayText: this.$t(
            "message.infoauto_orders_page.statuses.not_migrated"
          ),
          value: "not_migrated",
          qty: this.orderStatusQty.not_migrated
        },
        {
          displayText: this.$t(
            "message.infoauto_orders_page.statuses.error_migrating"
          ),
          value: "error_migrating",
          qty: this.orderStatusQty.error_migrating
        },
        {
          displayText: this.$t(
            "message.infoauto_orders_page.statuses.migrated"
          ),
          value: "migrated",
          qty: this.orderStatusQty.migrated
        }
      ];
    }
  },
  mounted() {
    if (this.$route.query.search) {
      let searchParams = new URLSearchParams(this.$route.query.search);
      for (let p of searchParams) {
        switch (p[1]) {
          case "true":
            p[1] = true;
            break;
          case "false":
            p[1] = false;
            break;
          case "null":
            p[1] = null;
            break;
          default:
            break;
        }
        if (p[0] === "otherFilters") {
          let otherFilters = p[1].split("&");
          otherFilters.forEach(element => {
            let filter = element.split("=");
            this.filters.otherFilters[filter[0]] = decodeURIComponent(
              filter[1]
            );
            console.log(decodeURIComponent(filter[1]));
          });
        } else {
          this.filters[p[0]] = decodeURIComponent(p[1]);
        }
      }
    }
    if (this.$route.query.orderOpen) {
      this.openOrder(this.$route.query.orderOpen);
    }
    if (this.$route.query.showFilters) {
      this.showFilters = this.$route.query.showFilters == "true";
    }
    this.loadOrders();
    this.detectFocusOut();
    this.getStatus();
  },
  methods: {
    ...mapGetters("general", ["getAdminSettings"]),
    infoautoExportEnabled() {
      console.log(this.getAdminSettings.get("infoauto_orders_sync_enabled"));
      const infoautoEnabled = this.getAdminSettings.get(
        "infoauto_orders_sync_enabled"
      );
      return infoautoEnabled?.value === "true" ? true : false;
    },
    getStatus() {
      console.log("get status");
      getOrdersQtyByInfoautoStatus().then(res => {
        console.log(res);
        this.orderStatusQty.not_migrated = res[camelize("not_migrated")] || 0;
        this.orderStatusQty.error_migrating =
          res[camelize("error_migrating")] || 0;
        this.orderStatusQty.migrated = res[camelize("migrated")] || 0;
      });
    },
    onWindowFocusChange(e) {
      console.log("window focus event", e);
      if ({ focus: 1 }[e.type]) {
        if (this.windowIsFocused) return;
        this.windowIsFocused = true;
        this.loadOrders();
        this.getStatus();
      } else if (this.windowIsFocused) {
        this.windowIsFocused = false;
      }
    },
    detectFocusOut() {
      this.windowIsFocused = false;
      window.addEventListener("focus", this.onWindowFocusChange);
      window.addEventListener("blur", this.onWindowFocusChange);
      window.addEventListener("pageshow", this.onWindowFocusChange);
      window.addEventListener("pagehide", this.onWindowFocusChange);
    },
    clearFilters() {
      this.filters.otherFilters = JSON.parse(
        JSON.stringify(baseFilters.otherFilters)
      );
      this.filtersKey++;
    },
    updateSearchFilter(search) {
      this.filters.page = 1;
      this.filters.search = search;
    },
    updateStatusFilter(status) {
      this.filters.page = 1;
      this.filters.exportStatus = status;
      this.showFilters = false;
    },
    async loadOrders() {
      this.apiCallId = new Date();
      let apiCallIdCurrent = this.apiCallId;
      const res = await getInfoautoOrders(this.filters).catch(() => {
        alert("Error getting orders");
      });
      if (apiCallIdCurrent !== this.apiCallId) {
        console.warn("new request in process");
        return;
      }
      this.orders = res.orders;
      this.totalItems = res.totalItems;
      this.totalItems = res.totalItems;
      this.totalPages = res.totalPages;
      this.loading = false;
    },
    previous() {
      if (this.filters.page > 1) {
        this.filters.page = this.filters.page - 1;
      }
    },
    next() {
      if (this.totalItems >= this.filters.limitPerPage * this.filters.page) {
        this.filters.page = this.filters.page + 1;
      }
    },
    toQuantity() {
      if (this.qtyPerPage * this.page > this.totalItems) {
        return this.orders.length;
      } else {
        return (
          this.filters.limitPerPage * (this.filters.page - 1) +
          this.orders.length
        );
      }
    },
    changeArrowDir(headerValue) {
      this.filters.page = 1;
      if (headerValue == this.filters.orderCol) {
        this.filters.orderDir =
          this.filters.orderDir == "desc" ? "asc" : "desc";
      } else {
        this.filters.orderCol = headerValue;
        this.filters.orderDir = "desc";
      }
    },
    openOrder(orderNumber) {
      this.openedOrder = orderNumber;
      this.showOrderModal = true;
      const index = this.orders.findIndex(
        order => order.orderNumber == this.openedOrder
      );
      if (index + 1 > this.orders.length - 1) {
        console.log("no tengo siguiente");
        this.hasNext = false;
      } else {
        console.log("xsi");
        this.hasNext = true;
      }

      // to do! = tengo previo?
      if (index - 1 < 0) {
        console.log("no tengo anterior");
        this.hasPrev = false;
      } else {
        console.log("si tengo anterior");
        this.hasPrev = true;
      }
    },
    exportAllOrders() {
      this.exportingOrders = true;
      exportAllOrdersInfoauto({})
        .then(res => {
          this.exportingOrders = false;
          this.loadOrders();
          this.getStatus();
          console.log(res.error, res.exported);
          this.$toast.success(
            "Orders exported successfully, \n" +
              res.exported +
              " orders exported, \n" +
              res.error +
              " orders with error",
            {
              position: "top"
            }
          );
        })
        .catch(() => {
          this.exportingOrders = false;
          this.$toast.error("Error exporting orders");
        });
    },
    openNextOrder() {
      const index = this.orders.findIndex(
        order => order.id == this.openedOrder
      );
      if (index + 1 > this.orders.length - 1) return;
      this.openOrder(this.orders[index + 1].orderNumber);
    },
    openPreviousOrder() {
      const index = this.orders.findIndex(
        order => order.id == this.openedOrder
      );
      if (index - 1 < 0) return;

      this.openOrder(this.orders[index - 1].orderNumber);
    }
  },
  beforeDestroy() {
    console.log("remove event listeners");
    window.removeEventListener("focus", this.onWindowFocusChange);
    window.removeEventListener("blur", this.onWindowFocusChange);
    window.removeEventListener("pageshow", this.onWindowFocusChange);
    window.removeEventListener("pagehide", this.onWindowFocusChange);
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/css/generic-variables.scss";

.content-main {
  .content {
    padding: 5px;
    width: 100%;
    .header {
      width: 100%;
      padding: 20px 15px;
    }
    .table {
      width: 100%;
      height: calc(100% - 200px);
      overflow-x: auto;
      margin-bottom: 10px;
      table {
        td {
          font-size: 14px;
          white-space: nowrap;
        }
      }
    }
    .footer {
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: space-between;
      .pages {
        display: flex;
        flex-direction: row;
        div {
          width: 75px;
        }
        .page-link {
          color: $link-color-1;
        }
      }
    }
  }
}
</style>
